import {
  formatCompactFavoritesCount,
  getDeterministicFavoritesByProductId,
} from 'src/utils/restructure/getDeterministicFavoritesByProductId'
import FavoritesHeartIcon from 'src/components/Icons/FavoritesHeartIcon'

type FavoritesCounterCompactProps = {
  productId?: string | number
  dataDyId: string
}

export default function FavoritesCounterCompact({
  productId,
  dataDyId,
}: Readonly<FavoritesCounterCompactProps>) {
  const normalizedProductId = String(productId ?? '').trim()

  if (!normalizedProductId) {
    return null
  }

  const favoritesCount = getDeterministicFavoritesByProductId(productId)
  const compactValue = formatCompactFavoritesCount(favoritesCount)

  return (
    <span
      data-dy-id={dataDyId}
      className="hidden h-4 shrink-0 items-center justify-end gap-1 text-xs font-bold text-restructure-action"
    >
      <FavoritesHeartIcon width={12} height={12} />
      {compactValue}
    </span>
  )
}
